import { ProductDescriptionPill } from "./product-description-pill";

export default ProductDescriptionPill;
